import {Brick, registerBrick} from 'olympe';

export default class IsGraphAPIResultEmpty extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} data
     * @param {function(boolean)} setIsEmpty
     */
    update($, [data], [setIsEmpty]) {
        try {
            let result = JSON.parse(data);

            if (Array.isArray(result)) {
                result = result[0];
            }

            if (typeof result === 'string') {
                result = JSON.parse(result);
            }

            const isEmpty = Array.isArray(result.value) && result.value.length === 0;
            setIsEmpty(isEmpty);
        } catch (error) {
            console.error('Invalid JSON data:', error);
            setIsEmpty(true);
        }
    }
}

registerBrick('019527aa948d3b34c908', IsGraphAPIResultEmpty);
